import React, { useState, useEffect } from "react";
import Select from "react-select";
import { OutTable, ExcelRenderer } from "react-excel-renderer";
import "../../../asset/css/excelcss.css";
import httpRequest from "../../../utils/Http";
import MyDataTable from "../../../component/MyDataTable";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import { openSignUrl } from "../../../utils/HelperFunction";
import { ONLY_RM_ASM_ACTION_PERMISSION } from "../../../constant/action_permission";

const UploadSfServiceablefile = ({ sfdetails, roleId }) => {
  const [formErrors, setFormErrors] = useState({});
  const [formData, setFormData] = useState({});
  const [applianceops, setApplianceOps] = useState([]);
  const [rows, setRows] = useState(null);
  const [cols, setcols] = useState(null);
  const [isSubmit, setSubmit] = useState(false);
  const [reloadList, setReload] = useState(true);
  const [filterApplianceId, setFilterApplianceId] = useState("");
  const [pincodeForm, setPincodeForm] = useState({});
  const [pincodeError, setPincodeError] = useState({});
  const [isPincodeSubmit, setPincodeSubmit] = useState(false);

  useEffect(() => {
    (async () => {
      // Replace this with your actual API call
      const response = await httpRequest("getappliancelist?isactive=1", {}, "GET");
      if (response.status && response.data?.rows) {
        const applianceList = response.data.rows;
        const options = [
          { label: "Select All", value: "select_all" },
          ...applianceList.map((item) => ({
            label: item.appliance_name,
            value: item.id,
          })),
        ];
        setApplianceOps(options);
      }
    })();
  }, []);

  const validateFrom = (value) => {
    const errors = {};
    //console.log(value);
    if (!value.appliance_id) {
      errors.appliance_id = "Appliance Name is Required";
    }

    if (!value.file) {
      errors.pincode_file = "Pincode File is Required (Only xlsx & xls file)";
    }

    return errors;
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();
    //console.log(formData);
    setSubmit(false);
    setFormErrors(validateFrom(formData));
    setSubmit(true);
  };

  const onSubmitSingleHandler = (e) => {
    e.preventDefault();
    setPincodeSubmit(false);
    setPincodeError(validateSingleFrom(pincodeForm));
    setPincodeSubmit(true);
  };

  const validateSingleFrom = (value) => {
    const errors = {};
    //console.log(value);
    if (!value.appliance_id) {
      errors.appliance_id = "Appliance Name is Required";
    }

    if (!value.pincode) {
      errors.pincode = "Pincode is Required";
    }

    return errors;
  };

  useEffect(() => {
    console.log('hi')
    console.log(pincodeError);
    console.log(isPincodeSubmit);
    (async () => {
      if (Object.keys(pincodeError).length === 0 && isPincodeSubmit) {
        let formData1 = pincodeForm;
        //  let formData1 = new FormData();
        //  formData1.append("file", formData.file);
        //  formData1.append("appliance_id", formData.appliance_id);
        //  formData1.append("sf_id", sfdetails.id);

        // formData.sf_id = sfdetails.id;
        formData1 = {
          ...formData1,
          sf_id: sfdetails.id,
          appliance_id_json: JSON.stringify(formData1.appliance_id),
        };
        document.getElementById("uploadSingleServiceabilityfile").reset();
        const data = await httpRequest(
          "addsingleserviceablepincode",
          formData1,
          "POST",
          "multipart/form-data"
        );

        if (data.status === true && data.message) {
          toast.success(data.message);
          setReload(true);
        } else {
          toast.error(data.message);
        }
        setSubmit(false);
      }
    })();
    //eslint-disable-next-line
  }, [isPincodeSubmit, pincodeError]);

  useEffect(() => {
    (async () => {
      if (Object.keys(formErrors).length === 0 && isSubmit) {
        let formData1 = formData;
        //  let formData1 = new FormData();
        //  formData1.append("file", formData.file);
        //  formData1.append("appliance_id", formData.appliance_id);
        //  formData1.append("sf_id", sfdetails.id);

        // formData.sf_id = sfdetails.id;
        formData1 = {
          ...formData1,
          sf_id: sfdetails.id,
          appliance_id_json: JSON.stringify(formData1.appliance_id),
        };
        document.getElementById("uploadServiceabilityfile").reset();
        const data = await httpRequest(
          "uploadserviceablefile",
          formData1,
          "POST",
          "multipart/form-data"
        );

        if (data.status === true && data.message) {
          toast.success(data.message);
          setRows(null);
          setcols(null);
          setReload(true);
        } else {
          toast.error(data.message);
        }
        setSubmit(false);
      }
    })();
    //eslint-disable-next-line
  }, [isSubmit, formErrors]);

  const columns = [
    {
      name: "SNo.",
      selector: (_, index) => index + 1,
    },
    {
      name: "File Name",
      selector: (row) => row.file_name,
      cell: (row) => (
        <Link
          to={"javascript:void(0)"}
          className="btn-link text-primary"
          onClick={() => openSignUrl(row.file_path)}
        >
          {row.file_name}
        </Link>
      ),
    },
    {
      name: "Agent Name",
      selector: (row) => row.agent_detail.name,
    },
    {
      name: "Status",
      selector: (row) => row.status,
    },
    {
      name: "Create Date",
      selector: (row) => new Date(row.createdAt).toDateString(),
    },
  ];

  const pincodeColumns = [
    {
      name: "SNo.",
      selector: (_, index) => index + 1,
    },
    {
      name: "Pincode",
      selector: (row) => row.pincode,
    },
    {
      name: "Create Date",
      selector: (row) => new Date(row.createdAt).toDateString(),
    },
    {
      name: "Delete",
      cell: (row) => (
        <button
          type="button"
          className="btn btn-danger"
          onClick={() => deleteHandler(row.id)}
        >
          Delete
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      exportXlsx: false,
    },
  ];

  const deleteHandler = async (id) => {
    if (id) {
      const data = await httpRequest(
        "deleteserviceablepincode?id=" + id,
        {},
        "POST"
      );
      if (data.status === true) {
        toast.success(data.message);
        setReload(true);
      } else {
        toast.error(data.message);
      }
    }
  };

    const handleChange = (selectedOptions, setData, formData) => {
    if (!selectedOptions) {
      setData({ ...formData, appliance_id: [] });
      return;
    }

    const isSelectAllClicked = selectedOptions.some((opt) => opt.value === "select_all");
    console.log(isSelectAllClicked)

    if (isSelectAllClicked) {
      // Select all except "Select All"
      const allOptions = applianceops.filter((opt) => opt.value !== "select_all");
     // console.log(allOptions)
     setData((prev) => ({
      ...prev,
      appliance_id: allOptions
     }))
    } else {
      setData({ ...formData, appliance_id: selectedOptions });
    }
  };

  return (
    <>
      <section className="content">
        <div className="container-fluid">
          <div className="card card-default">
            <div className="card-header d-flex justify-content-between align-items-center">
              <div className="card-title">
                <ul className="nav nav-pills">
                  <li className="nav-item">
                    <a
                      id="bulkserviceablefile_tab"
                      className="nav-link active tabc"
                      href="#bulkserviceablefile"
                      data-toggle="tab"
                    >
                      Bulk Upload Serviceable File
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      id="singleuploadpincode_tab"
                      className="nav-link tabc"
                      href="#singleuploadpincode"
                      data-toggle="tab"
                    >
                      Add Single Serviceable Pincode
                    </a>
                  </li>
                </ul>
              </div>
              <span>
                <button
                  type="button"
                  className="btn-link text-primary border-0 bg-transparent"
                  onClick={() =>
                    openSignUrl("samplefolder/sfpincodeserviceable.xlsx")
                  }
                >
                  Download Sample File
                </button>
              </span>
            </div>

            <div className="card-body">
              <div className="tab-content">
                {/* BULK UPLOAD TAB */}
                <div className="tab-pane tabc active" id="bulkserviceablefile">
                  <form
                    id="uploadServiceabilityfile"
                    onSubmit={onSubmitHandler}
                    encType="multipart/form-data"
                  >
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Appliance *
                            <span className="text-danger">
                              {formErrors?.appliance_id}
                            </span>
                          </label>
                          <Select
                            name="appliance_id"
                            options={applianceops}
                            isMulti
                            value={formData.appliance_id}
                            onChange={(val) =>
                              handleChange(val, setFormData, formData)
                            }
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Upload Pincode File *
                            <span className="text-danger">
                              {formErrors?.pincode_file}
                            </span>
                          </label>
                          <input
                            name="file"
                            type="file"
                            className="form-control"
                            accept=".xlsx,.xls"
                            onChange={(e) => {
                              const files = e.target.files;
                              if (files?.[0]) {
                                const fileName = files[0].name.toLowerCase();
                                const regex = /\.(xlsx|xls)$/;

                                if (!regex.test(fileName)) {
                                  setFormErrors({
                                    pincode_file:
                                      "Only .xlsx or .xls files are allowed.",
                                  });
                                } else {
                                  setRows(null);
                                  setcols(null);
                                  ExcelRenderer(files[0], (err, resp) => {
                                    if (!err) {
                                      setRows(resp.rows);
                                      setcols(resp.cols);
                                    }
                                  });
                                  setFormData({ ...formData, file: files[0] });
                                }
                              } else {
                                setFormErrors({
                                  pincode_file: "File is required.",
                                });
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    {rows && (
                      <div className="row">
                        <div className="col-md-12 restrict-card">
                          <OutTable
                            data={rows}
                            columns={cols}
                            tableClassName="table table-bordered table-striped dataTable dtr-inline"
                            tableHeaderRowClass="heading"
                          />
                        </div>
                      </div>
                    )}

                    {ONLY_RM_ASM_ACTION_PERMISSION.includes(roleId) && (
                      <div className="row justify-content-center mt-4">
                        <input
                          type="submit"
                          className="form-control btn btn-primary col-md-4"
                          value="Submit"
                        />
                      </div>
                    )}
                  </form>
                </div>

                {/* SINGLE PINCODE TAB */}
                <div className="tab-pane tabc" id="singleuploadpincode">
                  <form
                    id="uploadSingleServiceabilityfile"
                    onSubmit={onSubmitSingleHandler}
                  >
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Appliance *
                            <span className="text-danger">
                              {pincodeError?.appliance_id}
                            </span>
                            
                          </label>
                          <Select
                            name="appliance_id"
                            options={applianceops}
                            value={pincodeForm.appliance_id}
                            isMulti
                             onChange={(val) =>
                              handleChange(val, setPincodeForm, pincodeForm)
                            }
                           
                            
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Pincode *
                            <span className="text-danger">
                              {pincodeError?.pincode}
                            </span>
                          </label>
                          <input
                            name="pincode"
                            type="text"
                            className="form-control"
                            placeholder="Enter Pincode"
                            value={pincodeForm?.pincode || ""}
                            maxLength={6}
                            pattern="\d{6}"
                            onChange={(e) => {
                              const value = e.target.value;
                              if (/^\d{0,6}$/.test(value)) {
                                setPincodeForm({
                                  ...pincodeForm,
                                  pincode: value,
                                });
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    {ONLY_RM_ASM_ACTION_PERMISSION.includes(roleId) && (
                      <div className="row justify-content-center mt-4">
                        <input
                          type="submit"
                          className="form-control btn btn-primary col-md-4"
                          value="Submit"
                        />
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <br />
      <br />
      <br />
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">
                    <ul className="nav nav-pills">
                      <li className="nav-item">
                        <a
                          id="filehistory_tab"
                          className="nav-link active tabc"
                          href="#filehistory"
                          data-toggle="tab"
                        >
                          File Upload History
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          id="uploaded_pincode_tab"
                          className="nav-link tabc"
                          href="#uploaded_pincode"
                          data-toggle="tab"
                        >
                          Uploaded Pincode
                        </a>
                      </li>
                    </ul>
                  </h3>
                </div>
                <div className="tab-content">
                  <div className="tab-pane tabc active" id="filehistory">
                    <MyDataTable
                      reloadList={reloadList}
                      columns={columns}
                      getDataListURL={`getfileuploadhistory?type=SF_PINCODE_EXCEL&entity_id=${sfdetails.id}`}
                      setReload={setReload}
                      exportName={"fileuploadlist"}
                    />
                  </div>
                  <div className="tab-pane tabc " id="uploaded_pincode">
                    <div className="row" style={{ margin: "20px" }}>
                      <div className="col-md-6">
                        <div className="form-group is-invalid ">
                          <label>Appliance *</label>
                          <Select
                            name="appliance_id"
                            options={applianceops}
                            onChange={(val) => {
                              setFilterApplianceId(val.value);
                              setReload(true);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    {filterApplianceId && sfdetails && (
                      <MyDataTable
                        reloadList={reloadList}
                        columns={pincodeColumns}
                        getDataListURL={`getuploadedserviceablepincode?appliance_id=${filterApplianceId}&sf_id=${sfdetails.id}`}
                        setReload={setReload}
                        exportName={"fileuploadlist"}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6"></div>
          </div>
        </div>
      </section>
    </>
  );
};

export default UploadSfServiceablefile;
